import { ForDevelopment } from './dev/developmentUI';
import { useGlobalStateSelector, words } from './globalState';
import { handleClickGetDuelRankingAll } from './duelRanking';
import {
  handleClickGoTop,
} from './monadomCore';
import { decimalAdjust } from './utils';
import iconCircleLeft from './arrow_circle_left_FILL0_wght400_GRAD0_opsz48.svg';
import iconCircleRight from './arrow_circle_right_FILL0_wght400_GRAD0_opsz48.svg';
import iconSearch from './search_FILL0_wght400_GRAD0_opsz48.svg';

// DUEL RANKING
function DuelRanking() {
  const state = useGlobalStateSelector(({ state }) => state);
  const dispatch = useGlobalStateSelector(({ dispatch }) => dispatch);
  const navigate = useGlobalStateSelector(({ navigate }) => navigate);
  const action = state.getDuelRanking.action;
  const duelRankingRecords = state.getDuelRanking.records[action.difficultyMode][action.gameMode][action.period].duelRanking;
  const pagingIndex = state.getDuelRanking.pagingIndex[action.difficultyMode][action.gameMode][action.period];
  const lastEvaluatedKey = state.getDuelRanking.lastEvaluatedKey[action.difficultyMode][action.gameMode][action.period][pagingIndex];

  let items;
  let searchFunction;
  let arrowLeft;
  let arrowRight;

  // アクションごとのitemsとsearchFunction設定。

  // if (state.getDuelRanking.action === 'duelRankingAll') {
  //   if (state.duelRankingAll.duelRanking !== undefined) {
  //     items = state.duelRankingAll.duelRanking.map( record => {
  //       if (true) {
  //         return <DuelRankingRecord record={record} />
  //       }
  //       else {
  //         return null;
  //       }
  //     });

  //     items.unshift(<DuelRankingRecordTitle />);
  //   }
  //   else {
  //     items = [<DuelRankingRecordTitle />];
  //   }

  //   searchFunction = (pagingIndex) => handleClickGetDuelRankingAll(state, dispatch, pagingIndex);
  // }

  if (duelRankingRecords !== undefined) {
    items = duelRankingRecords.map( record => {
      if (true) {
        return <DuelRankingRecord record={record} action={action} />
      }
      else {
        return null;
      }
    });

    items.unshift(<DuelRankingRecordTitle />);
  }
  else {
    items = [<DuelRankingRecordTitle />];
  }

  searchFunction = (pagingIndex) => handleClickGetDuelRankingAll(state, dispatch, pagingIndex);


  // 矢印

  if ( pagingIndex >= 1 ) {
    arrowLeft = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => searchFunction(pagingIndex - 1) }
      >
        <img className='size2x2' src={iconCircleLeft} alt='left' />
      </button>
    </div>
  }
  else {
    arrowLeft = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  if (lastEvaluatedKey !== undefined && lastEvaluatedKey !== null) {
    arrowRight = <div>
      <button className='flexRow justifyContentCenter alignItemsCenter size2x2Large backgroundColorTransparent borderNone cursor borderRadiusCircle riseOut2 '
        onClick={ () => { searchFunction(pagingIndex + 1) } }
      >
        <img className='size2x2' src={iconCircleRight} alt='right' />
      </button>
    </div>
  }
  else {
    arrowRight = <div>
      <button className='size2x2Large backgroundColorTransparent borderNone' disabled={true} >
        <div className='size2x2' />
      </button>
    </div>
  }

  // 集計期間

  let period;

  if (action.period === 'monthly') {
    period =
    <div className='marginSide1' >
      { `${state.config.clientParameters.statisticsParameters.thisYear}年${state.config.clientParameters.statisticsParameters.thisMonth}月` }
    </div>
  }

  // ランキング戦賞品

  let prize;

  if (state.config.clientParameters.ranking.prize.display === 'normal') {
    prize =
    <button className='borderNone backgroundColorWhite focusEffect01 cursor borderRadius2 riseOut2 ' tabindex='0'
      onClick={ () => {
        window.open(state.config.clientParameters.ranking.prize.url);
      }}
    >
      { state.config.clientParameters.ranking.prize.face }
    </button>;
  }

  const headerFixed =
  <div className='z200FixedZero widthMax backgroundColorWhiteTransparent '>
    <div className='flexRow justifyContentFlexEnd marginBottom1' >
      <button className='button2' onClick={ () => handleClickGoTop(state, dispatch, navigate) }>
        { words.back[state.language] }
      </button>
    </div>
  </div>;

  const headerRelative =
  <div className='widthMax height6 ' >
  </div>;


  return (
    <div>
      {/* PC */}
      <div className="visibleMiddleOrMore">
        <div className='flexColumn'>
          { headerRelative }
          {/*
            <div className='marginSide2'>
              総合の勝率で順位をつけています。同率の場合は、ランダムに順位を表示しています。
            </div>
          */}
          {/* history */}
          <div className='flexRow justifyContentFlexStart alignItemsCenter '>
            {/* action */}
            <div className='flexRow justifyContentSpaceAround marginSide0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.difficultyMode === 'advanced' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'difficultyMode'], value: 'advanced'});
                }}
              >
                {words.advancedMode[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.difficultyMode === 'simple' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'difficultyMode'], value: 'simple'});
                }}
              >
                {words.simpleMode[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.gameMode === 'human' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'gameMode'], value: 'human'});
                }}
              >
                {words.pvp[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.gameMode === 'computer' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'gameMode'], value: 'computer'});
                }}
              >
                {words.pvc[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.period === 'lifetime' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'period'], value: 'lifetime'});
                }}
              >
                {words.lifetime[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.period === 'monthly' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'period'], value: 'monthly'});
                }}
              >
                {words.monthly[state.language]}
              </button>
            </div>
            <button className='button1' tabindex='0'
              onClick={ () => {
                dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'lastRank', action.difficultyMode, action.gameMode, action.period], value: []});
                searchFunction(0);
              }}
            >
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
            { arrowLeft }
            { arrowRight }
            { period }
            <div className='marginSide1' >
              { prize }
            </div>
          </div>
          { items }
          {/* development */}
          <div>
            { process.env.REACT_APP_ENVIRONMENT === 'dev' ? <ForDevelopment /> : null }
          </div>
        </div>
      </div>
      {/* SP */}
      <div className="visibleSmallOrLess">
        <div className='flexColumn widthMax'>
          { headerRelative }
          {/*
            <div className='flexRow justifyContentFlexStart widthMax marginBottom1' >
              <div className=''>
                総合の勝率で順位をつけています。同率の場合は、ランダムに順位を表示しています。
              </div>
            </div>
          */}
          {/* control */}
          {/* action */}
          <div className='flexColumn widthMax padding0p5 '>
            <div className='flexRow justifyContentSpaceAround widthMax padding0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.difficultyMode === 'advanced' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'difficultyMode'], value: 'advanced'});
                }}
              >
                {words.advancedMode[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.difficultyMode === 'simple' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'difficultyMode'], value: 'simple'});
                }}
              >
                {words.simpleMode[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentSpaceAround widthMax padding0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.gameMode === 'human' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'gameMode'], value: 'human'});
                }}
              >
                {words.pvp[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.gameMode === 'computer' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'gameMode'], value: 'computer'});
                }}
              >
                {words.pvc[state.language]}
              </button>
            </div>
            <div className='flexRow justifyContentSpaceAround widthMax padding0p5 '>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.period === 'lifetime' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'period'], value: 'lifetime'});
                }}
              >
                {words.lifetime[state.language]}
              </button>
              <button className={'box3 focusEffect01 riseOut2 ' + (state.getDuelRanking.action.period === 'monthly' ? 'colorRed borderSelected' : 'borderNone')}
                tabindex='0'
                onClick={ () => {
                  dispatch({type: 'setStateMultiLayers', keys: ['getDuelRanking', 'action', 'period'], value: 'monthly'});
                }}
              >
                {words.monthly[state.language]}
              </button>
            </div>
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginBottom1 '>
            <button className='button1 marginSide1' tabindex='0' onClick={ () => searchFunction(0) } >
              <img className='size2x2' src={iconSearch} alt='search' />
            </button>
            <div className='marginSide1' >
              { arrowLeft }
            </div>
            <div className='marginSide1' >
              { arrowRight }
            </div>
          </div>
          <div className='flexRow justifyContentFlexStart alignItemsCenter marginBottom1 '>
            <div className='marginSide1' >
              { period }
            </div>
            <div className='marginSide1' >
              { prize }
            </div>
          </div>
          { items }
        </div>
      </div>
      { headerFixed }
    </div>
  );
}

// DUEL RANKING RECORD TITLE
function DuelRankingRecordTitle() {
  const state = useGlobalStateSelector(({ state }) => state);

  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin5' >
            { words.rank[state.language] }
          </div>
          <div className='marginSide1 widthMin10' >
            { words.userName[state.language] }
          </div>
          <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin15' >
            <div>
              { words.scoreDetail[state.language] }
            </div>
          </div>
          {/*
            <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin15' >
              <div>
                { words.overall[state.language] }
              </div>
              <div>
                { words.scoreDetail[state.language] }
              </div>
            </div>
            <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin15' >
              <div>
                { words.pvp[state.language] }
              </div>
              <div>
                { words.scoreDetail[state.language] }
              </div>
            </div>
            <div className='flexColumn justifyContentCenter alignItemsCenter marginSide1 widthMin15' >
              <div>
                { words.pvc[state.language] }
              </div>
              <div>
                { words.scoreDetail[state.language] }
              </div>
            </div>
          */}
          {/*
            <button className='dummyPadButton1 backgroundColorMonacottoAlmostWhite' disabled={true} />
          */}
        </div>
      </div>
      {/* SP */}
      <div className='visibleMiddleOrLess boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
        <div className='flexRow justifyContentFlexEnd alignItemsCenter width98PC'>
          <div>
            { words.scoreDetail[state.language] }
          </div>
        </div>
      </div>
    </div>
  );
}

// DUEL RANKING RECORD
function DuelRankingRecord(props) {
  const state = useGlobalStateSelector(({ state }) => state);
  const record = props.record;
  const difficultyMode = props.action.difficultyMode;
  const gameMode = props.action.gameMode;
  const period = props.action.period;

  const winRateAttributeName = {
    simple: {
      human: {
        lifetime: 'winRateHuman',
        monthly: 'winRateSimpleHumanMonthly',
      },
      computer: {
        lifetime: 'winRateComputer',
        monthly: 'winRateSimpleComputerMonthly',
      },
      overall: {
        lifetime: 'winRateOverall',
        monthly: 'winRateSimpleOverallMonthly',
      },
    },
    advanced: {
      human: {
        lifetime: 'winRateAdvancedHumanLifetime',
        monthly: 'winRateAdvancedHumanMonthly',
      },
      computer: {
        lifetime: 'winRateAdvancedComputerLifetime',
        monthly: 'winRateAdvancedComputerMonthly',
      },
      overall: {
        lifetime: 'winRateAdvancedOverallLifetime',
        monthly: 'winRateAdvancedOverallMonthly',
      },
    },
  }

  const statistics = `${decimalAdjust('round', record[winRateAttributeName[difficultyMode][gameMode][period]] * 100, -2)}% [${record.statistics[difficultyMode][gameMode][period].numberOfDuels}] ${record.statistics[difficultyMode][gameMode][period].win.total} - ${record.statistics[difficultyMode][gameMode][period].lose.total} - ${record.statistics[difficultyMode][gameMode][period].draw.total}`;

  // const overall = `${decimalAdjust('round', record[winRateAttributeName[difficultyMode].overall[period]] * 100, -2)}% [${record.statistics[difficultyMode].human[period].numberOfDuels + record.statistics[difficultyMode].computer[period].numberOfDuels}] ${record.statistics[difficultyMode].human[period].win.total + record.statistics[difficultyMode].computer[period].win.total} - ${record.statistics[difficultyMode].human[period].lose.total + record.statistics[difficultyMode].computer[period].lose.total} - ${record.statistics[difficultyMode].human[period].draw.total + record.statistics[difficultyMode].computer[period].draw.total}`;

  // const pvp = `${decimalAdjust('round', record[winRateAttributeName[difficultyMode].human[period]] * 100, -2)}% [${record.statistics[difficultyMode].human[period].numberOfDuels}] ${record.statistics[difficultyMode].human[period].win.total} - ${record.statistics[difficultyMode].human[period].lose.total} - ${record.statistics[difficultyMode].human[period].draw.total}`;

  // const pvc = `${decimalAdjust('round', record[winRateAttributeName[difficultyMode].computer[period]] * 100, -2)}% [${record.statistics[difficultyMode].computer[period].numberOfDuels}] ${record.statistics[difficultyMode].computer[period].win.total} - ${record.statistics[difficultyMode].computer[period].lose.total} - ${record.statistics[difficultyMode].computer[period].draw.total}`;

  // let buttons;
  // let popup;

  // popup = { type: 'duelHistoryDetail', body: record };
  // buttons =
  // <button className='button1'
  //   onClick={ () => {
  //     dispatch({ type: 'setStateMultiLayers', keys: ['getDuelHistory', 'round'], value: 0 });
  //     dispatch({ type: 'setStateMultiLayers', keys: ['popup', 0], value: popup });
  //   }}
  // >
  //   <img className='size2x2' src={iconDetail} />
  // </button>;


  return (
    <div>
      {/* PC */}
      <div className="visibleLargeOrMore">
        <div className='boxHistory flexRow justifyContentSpaceBetween alignItemsCenter textCenter'  >
          <div className='marginSide1 widthMin5' >
            { record.rank }
          </div>
          <div className='marginSide1 widthMin10' >
            { record.userName }
          </div>
          <div className='marginSide1 widthMin15' >
            { statistics }
          </div>
          {/*
            <div className='marginSide1 widthMin15' >
              { overall }
            </div>
            <div className='marginSide1 widthMin15' >
              { pvp }
            </div>
            <div className='marginSide1 widthMin15' >
              { pvc }
            </div>
          */}
          {/* buttons */}
        </div>
      </div>
      {/* SP */}
      <div className="visibleMiddleOrLess">
        <div className='boxMonacotto1SmallScreen flexColumn alignItemsFlexStart '  >
          {/*
          <div className='flexRow justifyContentFlexEnd alignItemsCenter width98PC'>
            {/ buttons /}
          </div>
          */}
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.rank[state.language] }
            </div>
            <div className='flexRow alignItemsCenter' >
              { record.rank }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.userName[state.language] }
            </div>
            <div className='' >
              { record.userName }
            </div>
          </div>
          <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
            <div className='' >
              { words.gameRecord[state.language] }
            </div>
            <div className='' >
              { statistics }
            </div>
          </div>
          {/*
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
              <div className='' >
                { words.overall[state.language] }
              </div>
              <div className='' >
                { overall }
              </div>
            </div>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
              <div className='' >
                { words.pvp[state.language] }
              </div>
              <div className='' >
                { pvp }
              </div>
            </div>
            <div className='flexRow justifyContentSpaceBetween alignItemsCenter width98PC'>
              <div className='' >
                { words.pvc[state.language] }
              </div>
              <div className='' >
                { pvc }
              </div>
            </div>
          */}
        </div>
      </div>
    </div>
  );
}

export {
  DuelRanking,
};